import { Component, OnInit, VERSION, ViewChild, Input, AfterViewInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { Result } from '@zxing/library';
import { Router } from '@angular/router';

export interface DialogData {
  registration?: string;
  vehicle_id?: string;
}

@Component({
  selector: 'app-qr-code-dialog',
  templateUrl: './qr-code-dialog.component.html',
  styleUrls: ['./qr-code-dialog.component.scss']
})
export class QrCodeDialogComponent implements OnInit, AfterViewInit {

  ngVersion = VERSION.full;

  @ViewChild('scanner', { static: false }) scanner: ZXingScannerComponent;
  @Input() data: DialogData = {};

  showScanBtn: boolean = false;
  showScanner: boolean = true;
  isLoading: boolean = true;
  hasDevices: boolean;
  hasPermission: boolean;
  qrResultString: string;
  qrResult: Result;
  showMetaDetails: boolean = false;

  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo;

  errorMessage: string = '';

  constructor(
    private router: Router,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    // Only put code here that does NOT use this.scanner
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.scanner.camerasFound) {
        this.scanner.camerasFound.subscribe((devices: MediaDeviceInfo[]) => {
          this.hasDevices = true;
          this.isLoading = false;
          this.availableDevices = devices;
          if (!this.currentDevice && devices.length > 0) {
            this.currentDevice = devices[0];
          }
        });
      }

      if (this.scanner.camerasNotFound) {
        this.scanner.camerasNotFound.subscribe(() => {
          this.hasDevices = false;
          this.isLoading = false;
        });
      }

      if (this.scanner.scanComplete) {
        this.scanner.scanComplete.subscribe((result: Result) => {
          if (result)
            this.qrResult = result;
        });
      }

      if (this.scanner.permissionResponse) {
        this.scanner.permissionResponse.subscribe((perm: boolean) => {
          this.hasPermission = perm;
        });
      }
    }, 0)
  }

  displayCameras(cameras: MediaDeviceInfo[]) {
    this.availableDevices = cameras;
  }

  handleQrCodeResult(resultString: string) {
    this.qrResultString = resultString;
    if (resultString) {
      try {
        // Expecting format: partTypeId=123;partUnitId=456
        const parts = resultString.split(';');
        const data: { [key: string]: string } = {};
        parts.forEach(pair => {
          const [key, value] = pair.split('=');
          if (key && value) data[key.trim()] = value.trim();
        });
        const partTypeId = data['partTypeId'];
        const partUnitId = data['partUnitId'];
        if (partTypeId && partUnitId) {
          this.errorMessage = '';
          this.showScanBtn = false;
          setTimeout(() => {
            this.showScanner = false;
            this.modalCtrl.dismiss({ partTypeId, partUnitId }, 'confirm');
          }, 1000);
        } else {
          this.errorMessage = 'Invalid QR code for part';
          this.showScanBtn = true;
        }
      } catch (e) {
        this.errorMessage = 'Invalid QR code format';
        this.showScanBtn = true;
      }
    }
  }

  onDeviceSelectChange(selectedValue: string) {
    this.currentDevice = this.availableDevices.find(x => x.deviceId === selectedValue);
  }

  stateToEmoji(state: boolean): string {
    const states = {
      undefined: '❔',
      null: '⭕',
      true: '✔',
      false: '❌'
    };
    return states['' + state];
  }

  buttonClick(handler: Function) {
    if (handler) { handler(); }
    this.modalCtrl.dismiss();
  }

  toggleDetails() {
    this.showMetaDetails = !this.showMetaDetails;
  }

  startScanner() {
    this.showScanner = false;
  }

  viewHistory(id: string) {
    this.closeDialog();
    this.router.navigate(['vehicle-history/' + id], { queryParams: { status: '3' } });
  }

  viewVehicleList() {
    this.closeDialog();
    this.router.navigate(['vehicle-list/']);
  }

  closeDialog() {
    this.modalCtrl.dismiss();
  }
}
